import { createContext } from 'react';

const ProfileContext = createContext();

export default ProfileContext;